"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utilities_1 = require("../utilities");
const SIZE = 36;
function generateData(name, colors) {
    const numFromName = (0, utilities_1.hashCode)(name);
    const range = colors && colors.length;
    const wrapperColor = (0, utilities_1.getRandomColor)(numFromName, colors, range);
    const preTranslateX = (0, utilities_1.getUnit)(numFromName, 10, 1);
    const wrapperTranslateX = preTranslateX < 5 ? preTranslateX + SIZE / 9 : preTranslateX;
    const preTranslateY = (0, utilities_1.getUnit)(numFromName, 10, 2);
    const wrapperTranslateY = preTranslateY < 5 ? preTranslateY + SIZE / 9 : preTranslateY;
    const data = {
        wrapperColor: wrapperColor,
        faceColor: (0, utilities_1.getContrast)(wrapperColor),
        backgroundColor: (0, utilities_1.getRandomColor)(numFromName + 13, colors, range),
        wrapperTranslateX: wrapperTranslateX,
        wrapperTranslateY: wrapperTranslateY,
        wrapperRotate: (0, utilities_1.getUnit)(numFromName, 360),
        wrapperScale: 1 + (0, utilities_1.getUnit)(numFromName, SIZE / 12) / 10,
        isMouthOpen: (0, utilities_1.getBoolean)(numFromName, 2),
        isCircle: (0, utilities_1.getBoolean)(numFromName, 1),
        eyeSpread: (0, utilities_1.getUnit)(numFromName, 5),
        mouthSpread: (0, utilities_1.getUnit)(numFromName, 3),
        faceRotate: (0, utilities_1.getUnit)(numFromName, 10, 3),
        faceTranslateX: wrapperTranslateX > SIZE / 6 ? wrapperTranslateX / 2 : (0, utilities_1.getUnit)(numFromName, 8, 1),
        faceTranslateY: wrapperTranslateY > SIZE / 6 ? wrapperTranslateY / 2 : (0, utilities_1.getUnit)(numFromName, 7, 2),
    };
    return data;
}
const AvatarBeam = ({ name, colors, size, square }) => {
    const data = generateData(name, colors);
    return `
    <svg
      viewBox="0 0 ${SIZE} ${SIZE}"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width="${size}"
      height="${size}"
    >
      <title>${name}</title>
      <mask id="mask__beam" maskUnits="userSpaceOnUse" x="0" y="0" width="${SIZE}" height="${SIZE}">
        <rect width="${SIZE}" height="${SIZE}" ${square ? '' : `rx="${SIZE * 2}"`} fill="#FFFFFF" />
      </mask>
      <g mask="url(#mask__beam)">
        <rect width="${SIZE}" height="${SIZE}" fill="${data.backgroundColor}" />
        <rect
          x="0"
          y="0"
          width="${SIZE}"
          height="${SIZE}"
          transform="
            translate(${data.wrapperTranslateX} ${data.wrapperTranslateY}) 
            rotate(${data.wrapperRotate} ${SIZE / 2} ${SIZE / 2}) 
            scale(${data.wrapperScale})"
          fill="${data.wrapperColor}"
          rx="${data.isCircle ? SIZE : SIZE / 6}"
        />
        <g
          transform="
            translate(${data.faceTranslateX} ${data.faceTranslateY})
            rotate(${data.faceRotate} ${SIZE / 2} ${SIZE / 2})"
        >
          ${data.isMouthOpen
        ? `
            <path
              d="M15 ${19 + data.mouthSpread} c2 1 4 1 6 0"
              stroke="${data.faceColor}"
              fill="none"
              stroke-linecap="round"
            />
          `
        : `
            <path
              d="M13 ${19 + data.mouthSpread} a1,0.75 0 0,0 10,0"
              fill="${data.faceColor}"
            />
            `}
          <rect
            x="${14 - data.eyeSpread}"
            y="${14}"
            width="1.5"
            height="2"
            rx="1"
            stroke="none"
            fill="${data.faceColor}"
          />
          <rect
            x="${20 + data.eyeSpread}"
            y="14"
            width="1.5"
            height="2"
            rx="1"
            stroke="none"
            fill="${data.faceColor}"
          />
        </g>
      </g>
    </svg>
  `;
};
exports.default = AvatarBeam;
